import React, { Component } from 'react'
import ViewContract from './ViewContract'
import Clients from '../../../../../api/Sales/Clients'
import { message, Select } from 'antd'
import Members from '../../../../../api/Members'
import ContractsApi from '../../../../../api/Sales/SalesContracts'
import DocumentsApi from '../../../../../api/Documents'
import { get, isEmpty, omit, pick } from 'lodash'
import { execute, strVal } from '../../../../../modules/Utils'
import withSpinning from '../../../../../elements/HOC/withSpinning'
import withUrlFetch from '../../../../../elements/Select/withUrlFetch'
import withSort from '../../../../../elements/HOC/withSort'
import { compose } from 'recompose'
import CustomSelect from '../../../../../elements/Select/CustomSelect'
import moment from 'moment'
import { checkForm } from '../../../../../modules/Utils'

class ViewContractCont extends Component {
  uuid = moment().millisecond()
  orderLineFormRef = React.createRef()
  terminationFormRef = React.createRef()

  constructor(props) {
    super(props)
    this.clientKey = props.match.params.key
    this.contractKey = get(props.match, 'params.contractKey')
    this.type = props.type
    this.state = {
      created: false,
      submitting: false,
      fetching: false,
      clientFetching: false,
      linesList: [],
      subtotal: {},
      linesCached: [],
      CustomerOrderSelect: Select,
      actions: [],
      member: {},
      client: {},
      contract: {},
      updatingState: false,
      visibleOrderLine: false,
      updatingBillingState: false,
    }
    this.contractApi = new ContractsApi()
    this.api = new Clients()
    this.memberApi = new Members()
    this.docsApi = new DocumentsApi()
  }

  async componentDidMount() {
    await this.fetch()
    await this.fetchLines()
  }

  fetch = async () => {
    try {
      this.setState({
        fetching: true,
      })
      const client = await this.api.getMember(this.clientKey)
      const memberResponse = await this.memberApi.get(this.clientKey)
      const contract = await this.contractApi.get(this.contractKey)
      const subtotal = await this.contractApi.subtotal(this.contractKey)
      const actions = await this.docsApi.actions('salesContracts', contract.status)
      let member = await memberResponse.json()
      this.setState({
        member,
        client,
        contract,
        actions,
        subtotal,
        fetching: false,
        clientFetching: false,
      })
    } catch (error) {
      message.error(error.errorMessage)
      this.setState({
        fetching: false,
        clientFetching: false,
      })
    }
  }
  fetchLines = async () => {
    if (this.contractKey) {
      try {
        this.setState({
          fetchingLines: true,
        })
        let linesList = await this.contractApi.lines.list(this.contractKey)
        let ProductsSelect = Select,
          url
        if (!isEmpty(strVal(this.state, 'contract.company._id'))) {
          const owner = strVal(this.state, 'contract.company._id')
          url = `products/` + `?owner=${owner}&state=Active` + '&select=*'
          ProductsSelect = compose(
            withUrlFetch({
              name: 'products',
              url: url,
              cache: true,
            }),
            withSpinning,
            withSort,
          )(CustomSelect)
        }
        this.setState({
          linesList,
          linesCached: linesList,
          ProductsSelect,
          productsUrl: url,
          fetchingLines: false,
        })
      } catch (e) {
        message.error(e.errorMessage)
        this.setState({
          fetchingLines: true,
        })
      }
    }
  }
  handleOps = async (operation, contract) => {
    const { approve, submit, revise, cancel, close, remove, reject } = this.contractApi
    const { client, member } = this.state
    const { history } = this.props
    switch (operation) {
      case 'revise':
        await execute(this, revise.bind(this, pick(contract, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break
      case 'update':
        history.push({
          pathname: `update`,
          state: { contract, client, member },
        })
        break
      case 'submit':
        await execute(this, submit.bind(this, pick(contract, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break
      case 'cancel':
        await execute(this, cancel.bind(this, pick(contract, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break
      case 'close':
        await execute(this, close.bind(this, pick(contract, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break
      case 'remove':
        try {
          await execute(this, remove.bind(this, pick(contract, ['_key', '_rev', '_id'])), message)
          history.replace({
            pathname: `/clients/${member._key}`,
            hash: 'contracts',
          })
        } catch (e) {}
        break
      case 'approve':
        await execute(this, approve.bind(this, pick(contract, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break
      case 'terminate':
        this.onShowTermination()
        break
      case 'lines':
        this.setState({
          visibleLines: true,
          linesType: 'contract',
          contract,
        })
        break
      case 'reject':
        await execute(this, reject.bind(this, pick(contract, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break
    }
  }
  handleCancel = () => {
    this.setState({
      visibleLines: false,
    })
  }
  updateContractState = async state => {
    try {
      this.setState({
        updatingState: true,
      })
      const contract = await this.contractApi.updateState({
        ...pick(this.state.contract, ['_id', '_key', '_rev']),
        state,
      })
      this.setState({
        updatingState: false,
        contract,
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({
        updatingState: false,
      })
    }
  }
  updateBillingState = async state => {
    try {
      this.setState({
        updatingBillingState: true,
      })
      const contract = await this.contractApi.updateState({
        ...pick(this.state.contract, ['_id', '_key', '_rev']),
        billingState: state,
      })
      this.setState({
        updatingBillingState: false,
        contract,
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({
        updatingBillingState: false,
      })
    }
  }
  removeLine = async () => {
    try {
      this.setState({
        removingLine: true,
      })
      const { orderLine } = this.state
      await this.contractApi.lines.remove(pick(orderLine, ['_id', '_rev', '_key']))
      this.setState({
        removingLine: false,
      })
      this.onCancelOrderLine()
      await this.fetchLines()
    } catch (error) {
      this.setState({
        removingLine: false,
      })
      console.error(error)
      message.error(error.errorMessage)
    }
  }
  addLine = async () => {
    let orderLine = await this.checkOrderLineFrom()
    try {
      this.setState({
        submittingLine: true,
      })
      orderLine.contract = pick(this.state.contract, ['_id'])
      orderLine.requisition = this.state.contract.requisition
      await this.contractApi.lines.add(orderLine)
      this.setState({
        submittingLine: false,
      })
      this.onCancelOrderLine()
      await this.fetchLines()
    } catch (error) {
      this.setState({
        submittingLine: false,
      })
      console.error(error)
      message.error(error.errorMessage)
    }
  }
  updateLine = async () => {
    let orderLine = await this.checkOrderLineFrom()
    try {
      this.setState({
        submittingLine: true,
      })
      orderLine.contract = pick(this.state.contract, ['_id'])
      orderLine.requisition = this.state.contract.requisition
      await this.contractApi.lines.update(omit(orderLine, ['invoiced', 'amount']))
      this.setState({
        submittingLine: false,
      })
      this.onCancelOrderLine()
      await this.fetchLines()
    } catch (error) {
      this.setState({
        submittingLine: false,
      })
      console.error(error)
      message.error(error.errorMessage)
    }
  }
  onShowOrderLine = (orderLine = {}, orderLineModalType = 'new') => {
    this.setState({
      visibleOrderLine: true,
      orderLine,
      orderLineModalType,
    })
  }
  onCancelOrderLine = () => {
    this.setState({
      visibleOrderLine: false,
      orderLine: {},
    })
  }
  onShowTermination = () => {
    this.setState({
      visibleTermination: true,
    })
  }
  onCancelTermination = () => {
    this.setState({
      visibleTermination: false,
    })
  }
  terminate = async () => {
    let termination = await this.checkTerminationFrom()
    try {
      this.setState({
        terminating: true,
      })
      await this.contractApi.terminate(termination)
      this.setState({
        terminating: false,
      })
      this.onCancelTermination()
      this.fetch()
    } catch (error) {
      this.setState({
        terminating: false,
      })
      console.error(error)
      message.error(error.errorMessage)
    }
  }
  checkOrderLineFrom = async () => {
    const values = await checkForm(this.orderLineFormRef)
    console.log(values)
    return {
      ...pick(this.state.orderLine, ['_id', '_rev', '_key']),
      ...values,
    }
    // return new Promise((res, rej) => {
    //   this.orderLineFormRef.current.props.form.validateFieldsAndScroll(
    //     (err, values) => {
    //       if (!err) {
    //         res({
    //           ...pick(this.state.orderLine, ['_id', '_rev', '_key']),
    //           ...values,
    //         })
    //       }
    //     },
    //   )
    // })
  }
  checkTerminationFrom = async () => {
    return new Promise((res, rej) => {
      this.terminationFormRef.current.props.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          res({
            ...pick(this.state.contract, ['_id', '_rev', '_key']),
            ...values,
          })
        }
      })
    })
  }
  onShowInvoice = () => {
    this.setState(prvState => ({
      visibleInvoice: true,
      invoice: {},
      billLines: prvState.linesList.map(a => ({
        ...a,
        invoiced: 0,
      })),
      order: prvState.contract,
    }))
  }
  onCancelInvoice = () => {
    this.setState({
      visibleInvoice: false,
    })
    this.fetchLines()
  }

  render() {
    return (
      <ViewContract
        {...this.state}
        {...pick(this, [
          'handleOps',
          'linesOps',
          'fetch',
          'orderLineFormRef',
          'terminationFormRef',
          'terminate',
          'onShowOrderLine',
          'onShowInvoice',
          'onCancelInvoice',
          'onCancelOrderLine',
          'onCancelTermination',
          'fetchLines',
          'addLine',
          'updateLine',
          'removeLine',
          'clientKey',
          'updateContractState',
          'updateBillingState',
          'handleCancel',
        ])}
      />
    )
  }
}

ViewContractCont.propTypes = {}
ViewContractCont.defaultProps = {}

export default ViewContractCont
